import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { getAccessToken } from './utils/auth';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { lang } = useParams();
  const token = getAccessToken();

  if (!token) {
    // Redirect to login with current path as redirect parameter
    const redirectPath = location.pathname + location.search;
    const loginPath = lang ? `/${lang}/login` : '/login';
    return <Navigate to={`${loginPath}?redirect=${encodeURIComponent(redirectPath)}`} replace />;
  }

  return <>{children}</>;
}

